import { FileSignature, Loader2 } from 'lucide-react';
import {
  ResumeCard,
  ResumeCardHeader,
} from '@/components/commercial/proposals/shared/summary-components';
import { cn } from '@/lib/utils';

interface ContractInstructionsProps {
  isSending: boolean;
  onSend?: () => void;
  disabled?: boolean;
}

const INSTRUCTIONS = [
  {
    id: 'send',
    text: 'Ao clicar em "Enviar contrato para assinatura", o documento será gerado e enviado via Clicksign.',
  },
  {
    id: 'receive',
    text: 'Você receberá um e-mail da Clicksign com o link para revisar e assinar eletronicamente.',
  },
  {
    id: 'after',
    text: 'Após a assinatura, esta etapa será liberada automaticamente para prosseguir com o aceite e pagamento.',
  },
] as const;

export function ContractInstructions({ isSending, onSend, disabled }: ContractInstructionsProps) {
  const actionDisabled = isSending || disabled || !onSend;

  return (
    <ResumeCard>
      <ResumeCardHeader
        title="Assinatura eletrônica do contrato"
        icon={<FileSignature className="h-4 w-4 text-gray-400" />}
      />
      <div className="space-y-5 px-5 py-5">
        <p className="text-sm leading-relaxed text-gray-600">
          O contrato desta proposta será assinado eletronicamente por meio da plataforma{' '}
          <span className="font-semibold text-gray-900">Clicksign</span>. Após o envio, o documento
          chega ao e-mail do destinatário cadastrado.
        </p>

        <ol className="space-y-3">
          {INSTRUCTIONS.map((step, index) => (
            <li key={step.id} className="flex gap-3">
              <span
                className="flex h-6 w-6 flex-none items-center justify-center rounded-full bg-gray-100 text-xs font-semibold text-gray-700"
                aria-hidden="true"
              >
                {index + 1}
              </span>
              <p className="pt-0.5 text-sm leading-relaxed text-gray-600">{step.text}</p>
            </li>
          ))}
        </ol>

        <button
          type="button"
          onClick={onSend}
          disabled={actionDisabled}
          className={cn(
            'inline-flex h-11 w-full items-center justify-center gap-2 rounded-lg bg-blue-600 px-6 text-sm font-semibold text-white transition-colors hover:bg-blue-700',
            'disabled:cursor-not-allowed disabled:opacity-60',
          )}
        >
          {isSending && <Loader2 className="h-4 w-4 animate-spin" />}
          {isSending ? 'Enviando...' : 'Enviar contrato para assinatura'}
        </button>
      </div>
    </ResumeCard>
  );
}
